module.exports = __webpack_public_path__ + "static/seaview.9ee43462.jpg";